export default function TermsPage() {
    return (
        <div className="container pt-5 mt-5 mb-5">
            <h2 className="text-center mb-3">
                <b>ข้อกำหนดการใช้งาน</b>
            </h2>
            <p>
                <b>1. บทนำ</b>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp; เว็บไซต์ ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว และแอพพลิเคชั่น ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว
                (ในข้อตกลงนี้จะเรียกว่า ”R-DNAM”) และพันธมิตรทางธุรกิจที่นำเสนอการบริการให้กับคุณ (ในข้อตกลงนี้จะเรียกว่า “เว็บไซต์และแอพพลิเคชั่น”)
                ภายใต้เงื่อนไขดังต่อไปนี้ เราขอความกรุณาให้คุณได้อ่านข้อตกลงดังต่อไปนี้อย่างละเอียด หากคุณไม่ยอมรับข้อตกลงและเงื่อนไขดังกล่าว
                กรุณาหลีกเลี่ยงหรืออย่าเข้าใช้งานที่เว็บไซต์และแอพพลิเคชั่นนี้
                การที่คุณใช้เว็บไซต์และแอพพลิเคชั่นนี้หรือเข้าไปดูข้อมูลในหน้าใดๆของเว็บไซต์และแอพพลิเคชั่นนี้
                ถือว่าคุณยอมรับข้อผูกพันทางกฎหมายที่ระบุไว้ในข้อตกลงและเงื่อนไขการใช้บริการนี้ โดยรวมถึงนโยบายความเป็นส่วนตัวที่ R-DNAM กำหนดขึ้นด้วย
            </p>

            <p>
                <b>2. ข้อมูลต่างๆในเว็บไซต์และแอพพลิเคชั่น</b>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp; ถึงแม้ว่า R-DNAM
                จะได้พยายามทุกวิถีทางที่จะทำให้ข้อมูลต่างๆในเว็บไซต์และแอพพลิเคชั่นของเรามีความถูกต้องมากที่สุด แต่ทาง R-DNAM
                เราก็ไม่สามารถรับประกันว่าข้อมูล และส่วนประกอบดังกล่าวมีความถูกต้อง สมบูรณ์เพียงพอ ทันกาลทันเวลา หรือ เหมาะสมกับวัตถุประสงค์ใดโดยเฉพาะ
                ทั้งนี้ R-DNAM จะไม่รับผิดสำหรับความผิดพลาดหรือการละเว้นใดๆในข้อมูลและส่วนประกอบนั้น
                (รวมไปถึงข้อมูลหรือเนื้อหาใดๆก็ตามที่มีบุคคลที่สามหรือรวมไปถึง ข้อมูลและการรับประกันที่มีการนำเสนอขึ้นมา R-DNAM
                ขอสงวนสิทธิ์ที่จะทำการแก้ไขเปลี่ยนแปลงส่วนหนึ่งส่วนใดของเว็บไซต์และแอพพลิเคชั่นหรือยุติการให้บริการได้ทุกเมื่อ
                ทั้งที่เป็นการถาวรหรือชั่วคราว โดยไม่จำเป็นต้องมีการแจ้งให้ทราบล่วงหน้าก็ได้ ข้อมูลและองค์ประกอบทุกๆส่วนในเว็บไซด์และแอพพลิเคชั่นนี้
                มีวัตถุประสงค์เพื่อให้ข้อมูลแก่ผู้บริโภคทั่วไปเท่านั้น ไม่มีข้อมูลส่วนหนึ่งส่วนใดที่มีวัตถุประสงค์เพื่อเป็นการให้คำแนะนำ การวินิจฉัย
                การให้คำปรึกษา แต่อย่างใด รวมถึงมิได้มีวัตถุประสงค์เพื่อการแลกเปลี่ยน
                พึงระลึกไว้ว่าคุณและผู้ติดตามของคุณใช้ข้อมูลที่ประกอบขึ้นในเว็บไซต์และแอพพลิเคชั่นของเราด้วยความเสี่ยงของตัวคุณเอง
                หากคุณพบข้อผิดพลาดหรือการละเลย เว้นว่างในส่วนใดของเว็บไซต์ของเรา กรุณาแจ้งให้เราทราบ
            </p>

            <p>
                <b>3. เครื่องหมายการค้าและลิขสิทธิ์</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; R-DNAM เป็นเจ้าของลิขสิทธิ์ เครื่องหมายการค้า สัญลักษณ์และส่วนประกอบอื่นๆ
                ที่ปรากฏในทุกๆหน้าของเว็บไซต์และแอพพลิเคชั่นนี้ (กล่าวโดยรวมคือ “เครื่องหมายการค้า”) ห้ามมิให้ผู้ใด หรือ บริษัทใด ทำการดัดแปลง
                จัดเก็บในระบบที่สามารถนำมาใช้งานได้ ถ่ายโอน ลอกเลียนแบบ เผยแพร่ หรือ
                ใช้ข้อมูลและส่วนประกอบนั้นโดยมิได้รับความยินยอมเป็นลายลักษณ์อักษรจาก R-DNAM
            </p>

            <p>
                <b>4. การยกเลิกอันเกิดจากความผิดพลาด</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; R-DNAM มีสิทธิอย่างเต็มที่ที่จะยกเลิกคำสั่งซื้อได้ทุกเมื่อ
                หากความผิดพลาดนั้นเกิดมาจากความผิดพลาดในการพิมพ์หรือความผิดพลาดที่มิได้มีการคาดการณ์ไว้ล่วงหน้า
                อันเป็นผลมาจากสินค้าในเว็บไซต์และแอพพลิเคชั่นที่มีการลงรายการไว้ไม่ถูกต้อง (ไม่ว่าจะเป็นการลงราคาผิด หรือ ลงรายละเอียดที่ผิด เป็นต้น)
                ในกรณีที่รายการสั่งซื้อนั้นเกิดการยกเลิกขึ้น และเราได้รับการชำระเงินสำหรับคำสั่งซื้อนั้นเสร็จสมบูรณ์เรียบร้อยแล้ว R-DNAM
                จะทำการคืนเงินให้ท่านเต็มจำนวนราคาสินค้า
            </p>

            <p>
                <b>5. การใช้งานอันไม่เหมาะสม</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; คุณตกลงใจที่จะไม่ใช้เว็บไซต์และแอพพลิเคชั่นของ R-DNAM เพื่อเป็นการส่งหรือประกาศถึงเนื้อหาหรือข้อมูลใดๆ
                อันเป็นการขัดต่อกฎหมาย ข่มขู่ รังควาน เจตนาทำลายชื่อเสียง หมิ่นประมาท หยาบคาย คุกคาม มุ่งร้าย ลามกอนาจาร ส่อไปในทางเรื่องเพศ ก้าวร้าว
                ทำให้ผู้อื่นไม่พอใจ ดูหมิ่นศาสนา รวมถึงรูปภาพลามกหรือผิดกฎหมายใดๆที่บังคับใช้ ด้วยเหตุนี้หากคุณได้ทำการส่งหรือประกาศถึงเนื้อหา หรือ
                ข้อความ รวมถึง รูปภาพใดๆ ที่กล่าวมาแล้วนั้น และทาง R-DNAM หรือ บุคคลที่สามใดๆก็ตาม
                ได้รับความเสียหายอันเนื่องมาจากเนื้อหาหรือข้อมูลของคุณ ไม่ว่าจะทางตรงหรือทางอ้อมก็ตามที คุณจะต้องเป็นผู้รับผิดชอบความเสียหาย
                รวมถึงหนี้สิน ค่าเสียหายและรายจ่ายอันเกิดขึ้นจากการที่ R-DNAM หรือ บุคคลที่ 3 ต้องสูญเสียไป
            </p>

            <p>
                <b>6. การรับประกัน</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; ไม่ว่าในกรณีใดๆ R-DNAM ไม่ขอรับประกัน รับรอง หรือ เป็นตัวแทน ต่อการนำเสนอเนื้อหาของผู้ใช้งาน หรือ ความคิดเห็น
                คำแนะนำ หรือคำรับประกันใดๆที่ปรากฏ (ไม่ว่าจะแจ้งไว้อย่างชัดเจนหรือบอกเป็นนัยยะทางกฎหมายก็ตามที) ในเว็บไซต์และแอพพลิเคชั่น ของเรา
                โดยหมายรวมถึงข้อมูลส่วนตัวของคุณ หรือผู้ติดตามของคุณที่มีการส่งผ่านระบบของเราด้วย
            </p>

            <p>
                <b>7. ข้อจำกัดความรับผิด</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; R-DNAM จะไม่รับผิดชอบในความเสียหายใดๆ รวมถึง ความเสียหาย
                สูญเสียและค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยทางตรงหรือโดยทางอ้อม โดยเฉพาะเจาะจง โดยบังเอิญ หรือ เป็นผลสืบเนื่องที่ตามมา
                รวมถึงผลลัพธ์อันเนื่องมาจากการเข้าใช้งานในเว็บไซต์และแอพพลิเคชั่นของเรา ไม่ว่าจะโดยตรงหรือโดยอ้อม
                ทั้งข้อมูลใดๆที่ปรากฏอยู่บนเว็บไซต์และแอพพลิเคชั่น ข้อมูลส่วนตัวของคุณหรือข้อมูลผู้ติดตามของคุณ
                ตลอดจนเนื้อหาและข้อมูลต่างๆที่มีการส่งผ่านระบบของเรา กล่าวให้เฉพาะเจาะจงลงไปคือ R-DNAM หรือ บุคคลที่สามใดๆ หรือ ข้อมูล
                เนื้อหาที่มีการนำเสนอขึ้นมา จะไม่ต้องรับผิดชอบทางกฎหมายใดๆต่อคุณหรือต่อบุคคลอื่นใด ทั้งต่อบริษัทใดๆก็ตามที่ต้องประสบกับความสูญเสีย
                เกิดค่าใช้จ่าย ไม่ว่าจะโดยตรงหรือโดยอ้อม หรือค่าใช้จ่ายอันเกิดขึ้นจากความล่าช้า ความไม่ถูกต้อง ความผิดพลาด หรือ
                การเว้นว่างของข้อมูลด้านราคาที่มีการแบ่งสรรปันส่วนกัน หรือ การส่งต่อกัน หรือ การกระทำใดๆอันเกิดจากความเชื่อถือในเนื้อหา หรือ
                เป็นเหตุให้เกิดการไม่ประสบผลสำเร็จ หรือ การหยุดชะงัก หรือ การสิ้นสุด
            </p>

            <p>
                <b>8. นโยบายการชำระเงิน</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; จ่ายผ่าน ธนาคารกสิกร หรือ กรุงเทพ กรุณาชำระเงินภายใน 7 วัน หลังทำการสั่งซื้อ หากไม่ชำระเงินภายในเวลาที่กำหนด
                ระบบจะ ทำการยกเลิกคำสั่งซื้อของท่านโดยอัตโนมัติ
            </p>

            <p>
                <b>9. ความเป็นส่วนตัว</b> <br />
                &nbsp;&nbsp;&nbsp;&nbsp; เราตระหนักดีถึงภาระหน้าที่ของเราในการรักษาข้อมูลความลับของลูกค้า
                และนอกเหนือจากภาระหน้าที่รักษาความลับต่อลูกค้า เรายังปฏิบัติตามบทบัญญัติว่าด้วยข้อมูลส่วนตัว (Data Privacy) ตลอดเวลา ในการรวบรวม รักษา
                และใช้ข้อมูลส่วนตัวของลูกค้า โดยเฉพาะอย่างยิ่งเราได้ปฏิบัติตามหลักปฏิบัติดังต่อไปนี้
                เว้นแต่ในกรณีที่ลูกค้าตกลงเป็นอย่างอื่นตามความเหมาะสม
            </p>
            <p style={{ marginLeft: "1em" }}>
                1. การรวบรวมข้อมูลส่วนตัวจากลูกค้าจะเป็นไปเพื่อวัตถุประสงค์ในการค้าที่เกี่ยวกับสุนัข หรือบริการที่เกี่ยวข้อง
                <br />
                2. ในทุกขั้นตอนการปฏิบัติจะมีการดำเนินการเพื่อให้แน่ใจว่าข้อมูลส่วนตัวของลูกค้ามีความถูกต้อง
                และจะไม่ถูกจัดเก็บข้อมูลไว้นานเกินความจำเป็น หรือจะถูกทำลายทิ้งตามระเบียบว่าด้วยระยะเวลาการเก็บรักษาข้อมูลภายในของเรา <br />
                3. ข้อมูลส่วนตัวจะไม่ถูกนำไปใช้เพื่อวัตถุประสงค์อื่นใดนอกเหนือไปจากวัตถุประสงค์ ณ
                เวลาที่รวบรวมข้อมูลหรือวัตถุประสงค์ที่เกี่ยวข้องโดยตรง <br />
                4. ข้อมูลส่วนตัวของลูกค้าจะได้รับการคุ้มครองจากการเข้าถึง การประมวลผล หรือการลบทิ้งที่เกิดขึ้นโดยไม่ได้รับอนุญาตหรือโดยบังเอิญ <br />
                5. ลูกค้ามีสิทธิแก้ไขข้อมูลส่วนตัวของตนซึ่งเราเก็บรักษาไว้ โดยเราจะดำเนินการกับคำร้องขอเข้าถึงหรือขอแก้ไขข้อมูลของลูกค้ารายนั้น ๆ
                ตามบทบัญญัติดังกล่าวข้างต้น
            </p>
            <p></p>
        </div>
    );
}
